import React from "react";
import { Row } from "../_ui";

export default function FreshnessGatesPanel({ form, setField }) {
  return (
    <>
      <div className="text-[11px] text-zinc-500 leading-relaxed font-mono mb-1">
        Prevents stale news from entering the DB or wasting AI tokens. Lower = stricter (fresher news only).
      </div>
      <Row label="Max source age at INGEST (hours)">
        <input
          data-testid="settings-max-source-age-hours"
          type="number"
          min={1}
          value={form.max_source_age_hours}
          onChange={(e) => setField("max_source_age_hours", parseInt(e.target.value) || 24)}
          className="admin-input w-24 bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
        <div className="text-[10px] text-zinc-500 font-mono mt-1">Drop RSS/API items older than this. Default 24h.</div>
      </Row>
      <Row label="Max source age at AI REWRITE (hours)">
        <input
          data-testid="settings-max-rewrite-age-hours"
          type="number"
          min={1}
          value={form.max_rewrite_age_hours}
          onChange={(e) => setField("max_rewrite_age_hours", parseInt(e.target.value) || 36)}
          className="admin-input w-24 bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
        <div className="text-[10px] text-zinc-500 font-mono mt-1">Skip Claude tokens if source aged past this while queued. Default 36h.</div>
      </Row>
      <Row label="Purge PENDING after (hours)">
        <input
          data-testid="settings-purge-pending-after-hours"
          type="number"
          min={1}
          value={form.purge_pending_after_hours}
          onChange={(e) => setField("purge_pending_after_hours", parseInt(e.target.value) || 6)}
          className="admin-input w-24 bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
        <div className="text-[10px] text-zinc-500 font-mono mt-1">Sweeper deletes pending rows older than this. Default 6h. $0 sunk cost.</div>
      </Row>
      <Row label="Auto-archive READY after (hours)">
        <input
          data-testid="settings-auto-archive-ready-after-hours"
          type="number"
          min={1}
          value={form.auto_archive_ready_after_hours}
          onChange={(e) => setField("auto_archive_ready_after_hours", parseInt(e.target.value) || 24)}
          className="admin-input w-24 bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
        />
        <div className="text-[10px] text-zinc-500 font-mono mt-1">AI work preserved (kept for dedup fingerprint) but hidden. Default 24h.</div>
      </Row>
    </>
  );
}
